module.exports = __webpack_public_path__ + "img/crysrub-vein.eac92c87.png";